export default "__VITE_ASSET__C1KCqA76__"